// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".language-select-box[data-v-1f234af1] {\n  background-color: inherit;\n  color: white;\n  position: absolute;\n  right: 10px;\n}\n.language-select-label[data-v-1f234af1] {\n  margin-right: 3px;\n}\n.language-select[data-v-1f234af1] {\n  background-color: inherit;\n  color: white;\n}\n", ""]);
// Exports
module.exports = exports;
